import { TextField, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import { connect } from 'react-redux';
import { evalTextAppearance, getRows } from "../function/text_function";
import TemplateHint from "./TemplateHint";
import TemplateLabel from "./TemplateLabel";

export const useStylesText = makeStyles((props) => ({
    text: {
        "& .MuiInputBase-root input":{
            fontFamily: "var(--font-family)",
            color: "var(--answer-color)",
            borderBottom: "1px solid var(--answer-color)",
            fontSize: "var(--font-size)",
            lineHeight: "var(--font-size)"
        },
        "& .MuiInput-underline:after":{
            borderBottom: "2px solid var(--answer-color)"
        },
        "& .MuiInput-underline:before": {
            borderBottom: "1px solid var(--answer-color)"
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before":{
            borderBottom: "2px solid var(--answer-color)"
        }
    },
    textMultile: {
        "& .MuiInputBase-root textarea":{
            fontFamily: "var(--font-family)",
            color: "var(--answer-color)",
            fontSize: "var(--font-size)",
            lineHeight: "var(--font-size)"
        },
        "& .MuiInput-underline:before":{
            borderBottom: "1px solid var(--answer-color)"
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before":{
            borderBottom: "2px solid var(--answer-color)"
        },
        "& .MuiInput-underline:after":{
            borderBottom: "2px solid var(--answer-color)"
        }
    }
}))
const TextFieldTemplate = (props) => {
    const classes = useStylesText(props)
    if(props.display?.indexOf("thousandsep")>-1){
        return(
            <>
                {
                    props.display.indexOf("text-nolabel") === -1 &&
                    <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
                }
                <TemplateHint hint={props["hint::"+props.language]}/>
                <TextField name={props.questionId} value={"1,000,000,000"} classes={{root : classes.text}} fullWidth InputProps={{readOnly: props.readonly}}/>
            </>
        )
    }else if(props.display?.indexOf("embed")>-1){
        return (
            <>
                {
                    props.display.indexOf("text-nolabel") === -1 &&
                    <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
                }
                <TextField name={props.questionId} placeholder={props["hint::"+props.language]} classes={{root : classes.text}} fullWidth InputProps={{readOnly: props.readonly}}/>
            </>
        )
    }else if(props.display?.indexOf("numbers")>-1){
        return (
            <>
                {
                    props.display.indexOf("text-nolabel") === -1 &&
                    <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
                }
                <TemplateHint hint={props["hint::"+props.language]}/>
                <TextField name={props.questionId} type="number" classes={{root : classes.text}} fullWidth InputProps={{readOnly: props.readonly}}/>
            </>
        )
    }else if(props.display?.indexOf("digisep(")>-1){
        let value = evalTextAppearance(props.display[0].replace("digisep(","digisep('1000000000',").trim())
        return (
            <>
                {
                    props.display.indexOf("text-nolabel") === -1 &&
                    <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
                }
                <TemplateHint hint={props["hint::"+props.language]}/>
                <TextField name={props.questionId} classes={{root : classes.text}} value={value} fullWidth InputProps={{readOnly: props.readonly}}/>
            </>
        )
    }else if(props.display?.indexOf("multiline")>-1){
        let row = getRows(props.display[0])
        return (
            <>
                {
                    props.display.indexOf("text-nolabel") === -1 &&
                    <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
                }
                <TemplateHint hint={props["hint::"+props.language]}/>
                <TextField name={props.questionId} classes={{root : classes.textMultile}}  fullWidth InputProps={{readOnly: props.readonly,}} multiline maxRows={row}/>
            </>
        )
    }else{
        let value = props.display[0]?.indexOf("upper")>-1 ? 
                    "HELLO WORLD!!!" :
                    (
                        props.display[0]?.indexOf("lower")>-1 ?
                        "hello world!!!" :
                        props.display[0]?.indexOf("proper")>-1 ?
                        "Hello World!!!" : ""
                    )
        return (
            <>
                {
                    props.display.indexOf("text-nolabel") === -1 &&
                    <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
                }
                <TemplateHint hint={props["hint::"+props.language]}/>
                <TextField name={props.questionId} classes={{root : classes.text}} value={value} fullWidth InputProps={{readOnly: props.readonly}}/>
            </>
        );
    }

    
};

const mapStateToProps = (state, props) => {
    return {
        ...props,
        display : state['questionsList'][props.questionId].display,
        required: state['questionsList'][props.questionId].required,
        readonly:  state['questionsList'][props.questionId].readonly,
        ["label::"+props.language] : state['questionsList'][props.questionId]["label::"+props.language],
        ["hint::"+props.language] : state['questionsList'][props.questionId]["hint::"+props.language]
    };
}

export default connect(mapStateToProps)(TextFieldTemplate);


